/*
 *   Copyright (c) 2020 BuserNet Consulting LLC
 *   All rights reserved.
 */
import { Geolocation } from '@capacitor/geolocation';
import { checkGeoPermission } from './checkGeoPermission';
import LocalStorageConst from '../../constant/localstorage.constant';
import { softRequestPermission } from './softRequestPermission';
import {
  setKeyValueInLocalStorage,
} from '../localstorage/setKeyValueInLocalStorage';
import { alertGeolocationPermissionIssue } from './alertGeolocationPermissionIssue';

const getCurrentLocationNative = async () => {
  const coordinates = await Geolocation.getCurrentPosition();
  setKeyValueInLocalStorage(LocalStorageConst.geoLocationPermissionGiven, 3);

  return coordinates;
};

/**
 *
 * @returns {coords: {latitude, longitude}}
 */
const getCurrentLocation = async (isFirstTimeAsk) => {
  try {
    const permission = checkGeoPermission();
    if (isFirstTimeAsk || permission === true) {
      const coordinates = await getCurrentLocationNative();
      return coordinates;
    }
    if (permission === null) {
      const softPermission = await softRequestPermission();
      if (softPermission) {
        const coordinates = await getCurrentLocationNative();
        return coordinates;
      }
      return null;
    }
    /**
     * No matter what old permission issue was before
     * Again give it a try once to access location service
     * maybe it might work. Anyways if issue it will be catched
     */
    const coordinates = await getCurrentLocationNative();
    return coordinates;
  } catch (ex) {
  /**
   * CODE
   * PERMISSION_DENIED: 1
   * POSITION_UNAVAILABLE: 2
   */
    console.log(ex);
    alertGeolocationPermissionIssue();
    const { code } = ex;
    setKeyValueInLocalStorage(LocalStorageConst.geoLocationPermissionGiven, code || 1);
    return null;
  }
};

export { getCurrentLocation };
